import { Icons } from '@agro-club/agroclub-shared'

import { FC, useState } from 'react'
import * as ColumnBoard from 'views/components/ColumnBoard/styled'
import { ToggleColumnContent } from './ToggleColumnContent'

type Props = {
  title: string
  count: number
  initialOpened: boolean
  children?: React.ReactNode
}

export const ColumnContentHeader: FC<Props> = ({ children, title, count, initialOpened }) => {
  const [open, setOpen] = useState(initialOpened)

  return (
    <>
      <ToggleColumnContent $open={open} onClick={() => setOpen((oldVal) => !oldVal)}>
        <div>
          {title} <ColumnBoard.Counter>{count}</ColumnBoard.Counter>
        </div>
        <Icons.IconArrowDownS />
      </ToggleColumnContent>
      {open && children}
    </>
  )
}
